"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactJss = _interopRequireDefault(require("react-jss"));
var _clsx = _interopRequireDefault(require("clsx"));
var _ContentEditable = _interopRequireDefault(require("./ContentEditable.style"));
var _utils = _interopRequireDefault(require("../utils/utils"));
var _cursor = _interopRequireDefault(require("../utils/cursor"));
var _fileUtils = _interopRequireDefault(require("../utils/fileUtils"));
var _dec, _class;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
let ContentEditable = (_dec = (0, _reactJss.default)(_ContentEditable.default), _dec(_class = class ContentEditable extends _react.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: ''
    };
    this.emitChange = this.emitChange.bind(this);
    this.handlePaste = this.handlePaste.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.inputRef = props.forwardRef || _react.default.createRef();
  }
  static getDerivedStateFromProps(props, state) {
    const {
      lineNumbers
    } = props;
    let value;
    if (props.value !== state.value) {
      if (_utils.default.isFirefox() || !lineNumbers) {
        value = props.value;
      } else if (props.value === '<br>') {
        value = '';
      } else {
        value = _utils.default.wrapLinesWithDiv(props.value);
      }
      return {
        value
      };
    }
    return null;
  }

  // fix caret position jump to start
  shouldComponentUpdate(nextProps, nextState) {
    const inputHtml = this.inputRef.current;
    if (this._formatText(nextState.value) !== this._formatText(inputHtml.innerHTML)) return true;
    const optional = ['placeholder', 'tabIndex', 'className', 'id', 'lineNumbers'];
    return optional.some(name => this.props[name] !== nextProps[name]);
  }

  // fix caret position jump to start
  componentDidUpdate() {
    var _inputHtml$innerHTML;
    const inputHtml = this.inputRef.current;
    const {
      value
    } = this.state;
    const formattedValue = this._formatText(value);
    if (inputHtml && formattedValue !== this._formatText(inputHtml.innerHTML)) {
      inputHtml.innerHTML = formattedValue;
    }
    this.lastHtml = (_inputHtml$innerHTML = inputHtml === null || inputHtml === void 0 ? void 0 : inputHtml.innerHTML) !== null && _inputHtml$innerHTML !== void 0 ? _inputHtml$innerHTML : '';
  }
  _formatText(value) {
    const {
      type
    } = this.props;
    if (type === 'text') {
      return _utils.default.stripHtml(value);
    }
    return _utils.default.sanitizeHtml(value);
  }

  // Emit handle onChange
  emitChange(e) {
    const inputHtml = this.inputRef.current;
    if (!inputHtml) return;
    let html = e.target.innerHTML;
    if (html !== this.lastHtml) {
      if (_utils.default.isFirefox()) html = html.replace(/^<br>$/, '');
      e = Object.assign({}, e, {
        target: {
          value: html
        }
      });
      this.handleChange(e, html);
    }
    this.lastHtml = html;
  }
  handleChange(e, value) {
    const {
      id,
      onChange
    } = this.props;
    onChange({
      id,
      value,
      error: false
    });
  }
  selectFiles(filesSource) {
    var _this = this;
    return (0, _asyncToGenerator2.default)(function* () {
      const {
        onUpload
      } = _this.props;
      const files = yield _fileUtils.default.makeFilesArr(filesSource);
      onUpload({
        value: files,
        error: false
      });
    })();
  }
  handlePaste(e) {
    const {
      onPaste
    } = this.props;
    if (onPaste) onPaste(e);
    e.preventDefault();
    const items = e.clipboardData.items;
    const images = [].slice.call(items).filter(i => i.type.includes('image'));
    if (images.length) {
      const files = images.map(item => item.getAsFile());
      this.selectFiles(files);
    } else {
      let text = e.clipboardData.getData('text/plain');
      text = _utils.default.stripHtml(text);
      document.execCommand('insertHTML', false, text);
    }
  }
  handleKeyDown(e) {
    const {
      onKeyDown
    } = this.props;
    const {
      value
    } = this.state;
    if (!value.length) {
      setTimeout(() => {
        var _this$inputRef;
        if ((_this$inputRef = this.inputRef) === null || _this$inputRef === void 0 ? void 0 : _this$inputRef.current) {
          _cursor.default.moveCursorToEnd(this.inputRef.current);
        }
      }, 10);
    }
    onKeyDown(e);
  }
  render() {
    const {
      id,
      classes,
      className,
      onKeyPress,
      onKeyUp,
      onFocus,
      onBlur,
      onDoubleClick,
      tabIndex,
      placeholder,
      visibility,
      lineNumbers,
      dataTestId
    } = this.props;
    const {
      value
    } = this.state;
    const formatValue = this._formatText(value);
    return /*#__PURE__*/_react.default.createElement("div", {
      id: id,
      className: (0, _clsx.default)(className, classes.contentEdit, {
        lineNumbers: !!lineNumbers
      }),
      ref: this.inputRef,
      dangerouslySetInnerHTML: {
        __html: formatValue
      },
      contentEditable: visibility === 'visible',
      onInput: this.emitChange,
      onFocus: onFocus,
      onBlur: onBlur,
      onKeyPress: onKeyPress,
      onKeyDown: this.handleKeyDown,
      onKeyUp: onKeyUp,
      tabIndex: tabIndex,
      placeholder: placeholder,
      onDoubleClick: onDoubleClick,
      onPaste: this.handlePaste,
      "data-testid": dataTestId
    });
  }
}) || _class);
ContentEditable.defaultProps = {
  visibility: 'visible',
  tabIndex: 0,
  placeholder: null,
  type: 'text',
  onChange: () => {},
  onFocus: () => {},
  onBlur: () => {},
  onClickRightIcon: () => {},
  onKeyPress: () => {},
  onKeyUp: () => {},
  onKeyDown: () => {},
  onDoubleClick: () => {},
  onUpload: () => {},
  rows: 5
};
var _default = exports.default = ContentEditable;